exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#float-cart[data-v-253760fc]{\n    width:100%;\n}\ntd[data-v-253760fc]{\n    vertical-align: middle !important;\n    white-space: nowrap;\n}\n.fixed-w[data-v-253760fc]{\n    width: 100px;\n}\n", ""]);

// exports
